/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import { Injectable, Inject } from '@angular/core';
import service = require("./breeze.entitymanager.service");
import base = require("./base.dataservice");

export function initialize(module: ng.IModule) {
    module.service(ApplicationUserDataService.Id, ApplicationUserDataService);

    ApplicationUserDataService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

@Injectable()
export class ApplicationUserDataService extends base.BaseDataService<Nema.Crew.Model.ApplicationUser> implements IApplicationUserDataService {

    constructor(
        @Inject("entityManagerService") entityManagerService: service.EntityManagerService,
        @Inject("breeze") breeze,
        @Inject("$log") $log,
        @Inject("$q") $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id = "applicationUserDataService";

    public get EntityName(): string {
        return "ApplicationUser";
    }

    public get EntitiesName(): string {
        return "ApplicationUsers";
    }

    public newUserRole(defaultRoleId: string): Nema.Crew.Model.UserRole {
        var newUserRole = this.entityManager.createEntity('UserRole', <Nema.Crew.Model.UserRole>{
            RoleId: defaultRoleId
        });

        return <Nema.Crew.Model.UserRole><any>newUserRole;
    }

    protected deleteRelatedEntities(user: Nema.Crew.Model.ApplicationUser): Promise<void> {
        user.UserRoles.forEach(userRole => (<breeze.Entity><any>userRole).entityAspect.entityState = this.breeze.EntityState.Deleted);
        var deleteRelations = this.entityManager.saveChanges();

        return <Promise<void>><any>deleteRelations;
    }
}

export interface IApplicationUserDataService extends base.IDataService<Nema.Crew.Model.ApplicationUser> {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/applicationusers.dataservice.ts